/**
 * [mutations description]
 * @type {Object}
 */
var mutations = {
  setUserInfo(state, userInfo) {
    state.userInfo = userInfo
  }
}

export default mutations
